import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/cancel.svg'
import _imports_1 from '@/assets/img/reset.svg'


const _hoisted_1 = {
  id: "directory",
  class: "view"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "top" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode("Directory"),
    /*#__PURE__*/_createElementVNode("span", null, "دليل")
  ])
], -1)
const _hoisted_3 = { class: "top" }
const _hoisted_4 = { class: "filterSelected flex wrap" }
const _hoisted_5 = { class: "title flex align-center" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode()
const _hoisted_7 = { class: "title flex align-center" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode()
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Cancel"
}, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 0,
  class: "title flex align-center"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Cancel"
}, null, -1)
const _hoisted_14 = {
  key: 1,
  class: "title flex align-center"
}
const _hoisted_15 = {
  key: 2,
  class: "title flex align-center"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode("RESET ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "Cancel"
}, null, -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]
const _hoisted_19 = { id: "directoryWrap" }
const _hoisted_20 = {
  key: 0,
  id: "wrapper-loading",
  class: "blue"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "loading" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]

export function render(_ctx, _cache) {
  const _component_Grid = _resolveComponent("Grid")
  const _component_Vue3Lottie = _resolveComponent("Vue3Lottie")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.$root.$refs.navbar.openSearch && _ctx.$root.$refs.navbar.openSearch(...args)))
          }, "Type:"),
          _hoisted_6,
          (_ctx.$root.$refs.navbar.searchType == 'individual' || _ctx.$root.$refs.navbar.searchType == 'all')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "filter blue flex center align-center active show",
                onClick: _cache[1] || (_cache[1] = $event => (_ctx.$root.$refs.navbar.setFilter('company','type','del','Companies')))
              }, "Freelancer"))
            : (_openBlock(), _createElementBlock("a", {
                key: 1,
                class: "filter blue flex center align-center",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.$root.$refs.navbar.setFilter('individual','type','add','Freelancer')))
              }, "Freelancer")),
          (_ctx.$root.$refs.navbar.searchType == 'company' || _ctx.$root.$refs.navbar.searchType == 'all')
            ? (_openBlock(), _createElementBlock("a", {
                key: 2,
                class: "filter blue flex center align-center active show",
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.$root.$refs.navbar.setFilter('individual','type','del','Freelancer')))
              }, "Companies"))
            : (_openBlock(), _createElementBlock("a", {
                key: 3,
                class: "filter blue flex center align-center",
                onClick: _cache[4] || (_cache[4] = $event => (_ctx.$root.$refs.navbar.setFilter('company','type','add','Companies')))
              }, "Companies"))
        ]),
        _createElementVNode("p", _hoisted_7, [
          _createElementVNode("span", {
            onClick: _cache[5] || (_cache[5] = $event => (_ctx.$root.$refs.navbar.toggleFilter('filterCountry')))
          }, "Country:"),
          _hoisted_8,
          (_ctx.$root.$refs.navbar.currentCountry != 'All')
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                class: "filter blue active flex center align-center show",
                onClick: _cache[6] || (_cache[6] = $event => (_ctx.$root.$refs.navbar.setFilterCountry(_ctx.$root.$refs.navbar.currentCountry,'country',_ctx.$root.$refs.navbar.currentCountry)))
              }, [
                _createTextVNode(_toDisplayString(_ctx.$root.$refs.navbar.currentCountry) + " ", 1),
                _hoisted_9
              ]))
            : (_openBlock(), _createElementBlock("a", _hoisted_10, _toDisplayString(_ctx.$root.$refs.navbar.currentCountry), 1))
        ]),
        (_ctx.$root.$refs.navbar.searchTag != 'all')
          ? (_openBlock(), _createElementBlock("p", _hoisted_11, [
              _createElementVNode("span", {
                onClick: _cache[7] || (_cache[7] = $event => (_ctx.$root.$refs.navbar.toggleFilter('filterTags')))
              }, "Tags:"),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$root.$refs.navbar.directoryTags, (tag) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(["filter blue active flex center align-center", {'show': _ctx.$root.$refs.navbar.selectedTags.indexOf(tag.slug) > -1}]),
                  onClick: $event => (_ctx.$root.$refs.navbar.tagSelection(tag,_ctx.$root.$refs.navbar.selectedTags.indexOf(tag.slug) > -1))
                }, [
                  _createTextVNode(_toDisplayString(tag.name) + " ", 1),
                  _hoisted_13
                ], 10, _hoisted_12))
              }), 256))
            ]))
          : (_openBlock(), _createElementBlock("p", _hoisted_14, [
              _createElementVNode("span", {
                onClick: _cache[8] || (_cache[8] = $event => (_ctx.$root.$refs.navbar.toggleFilter('filterTags')))
              }, "Tags:"),
              _createElementVNode("a", null, _toDisplayString(_ctx.$root.$refs.navbar.currentTag), 1)
            ])),
        (_ctx.$root.$refs.navbar.searchType != 'all' || _ctx.$root.$refs.navbar.searchCountry != 'all' || _ctx.$root.$refs.navbar.searchTag != 'all')
          ? (_openBlock(), _createElementBlock("p", _hoisted_15, [
              _createElementVNode("a", {
                class: "reset filter flex center align-center",
                onClick: _cache[9] || (_cache[9] = $event => (_ctx.$root.$refs.navbar.setFilter('all','type')))
              }, _hoisted_18)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      (!_ctx.directory || _ctx.directory.length == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, _hoisted_22))
        : _createCommentVNode("", true),
      (_ctx.directory && _ctx.directory.length > 0)
        ? (_openBlock(), _createBlock(_component_Grid, {
            key: 1,
            posts: _ctx.directory.slice(0,_ctx.numMore),
            section: 'directory'
          }, null, 8, ["posts"]))
        : _createCommentVNode("", true),
      (_ctx.directory && _ctx.numMore < _ctx.directory.length)
        ? (_openBlock(), _createElementBlock("a", {
            key: 2,
            href: "",
            onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
          }, [
            (_ctx.LoadJSON)
              ? (_openBlock(), _createBlock(_component_Vue3Lottie, {
                  key: 0,
                  ref: "loadCom",
                  class: "loadMore",
                  animationData: _ctx.LoadJSON,
                  height: 115,
                  width: 294,
                  loop: true,
                  autoPlay: false,
                  onMouseover: _ctx.overAnim,
                  onMouseout: _ctx.outAnim
                }, null, 8, ["animationData", "onMouseover", "onMouseout"]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}